module.exports = "images/play.ad9066e3.png";